import PropTypes from 'prop-types';
import React from 'react';
import { SimpleSnapshotContainer as SnapshotContainer, SnapshotItem } from 'ctm-components';

const CoverAmountsDetails = ({
    totalRebuildCost,
    totalContentReplacementCost,
    totalUnspecifiedPortableItems,
    bicyclesCover,
    jewelryWatchesCover,
    clothingCover,
    sportingEquipmentCover,
    musicalInstrumentsCover,
    photographicEquipmentCover,
    portableItems,
    onClick,
    getHref
}) => {
    const coverDetailsUrl = 'cover_details';
    const personalEffectsUrl = 'personal_effects';
    return (
        <SnapshotContainer title="Cover Amounts">
            { totalRebuildCost && <SnapshotItem identifier="totalRebuildCost" href={getHref(coverDetailsUrl)} label={`Home replacement - ${totalRebuildCost}`} onClick={() => onClick(coverDetailsUrl)} /> }
            { totalContentReplacementCost && <SnapshotItem identifier="replacementCost" href={getHref(coverDetailsUrl)} label={`Contents replacement - ${totalContentReplacementCost}`} onClick={() => onClick(coverDetailsUrl)} /> }
            { totalUnspecifiedPortableItems
                && <SnapshotItem identifier="unspecifiedCover" href={getHref(personalEffectsUrl)} label={`Unspecified personal effects - ${totalUnspecifiedPortableItems}`} onClick={() => onClick(personalEffectsUrl)} />}
            { bicyclesCover && <SnapshotItem identifier="bicyclesCover" href={getHref(personalEffectsUrl)} label={`Bicycles - ${bicyclesCover}`} onClick={() => onClick(personalEffectsUrl)} /> }
            { jewelryWatchesCover && <SnapshotItem identifier="jewelCover" href={getHref(personalEffectsUrl)} label={`Jewelery / Watches - ${jewelryWatchesCover}`} onClick={() => onClick(personalEffectsUrl)} /> }
            { clothingCover && <SnapshotItem identifier="clothingCover" href={getHref(personalEffectsUrl)} label={`Clothing - ${clothingCover}`} onClick={() => onClick(personalEffectsUrl)} /> }
            { sportingEquipmentCover && <SnapshotItem identifier="sportCover" href={getHref(personalEffectsUrl)} label={`Sporting Equipment - ${sportingEquipmentCover}`} onClick={() => onClick(personalEffectsUrl)} /> }
            { musicalInstrumentsCover && <SnapshotItem identifier="musicCover" href={getHref(personalEffectsUrl)} label={`Musical Instruments - ${musicalInstrumentsCover}`} onClick={() => onClick(personalEffectsUrl)} /> }
            { photographicEquipmentCover && <SnapshotItem identifier="photoCover" href={getHref(personalEffectsUrl)} label={`Photographic equipment - ${photographicEquipmentCover}`} onClick={() => onClick(personalEffectsUrl)} /> }
            { portableItems && <SnapshotItem identifier="personalEffectsCover" href={getHref(personalEffectsUrl)} label={`Personal Effects - ${portableItems}`} onClick={() => onClick(personalEffectsUrl)} /> }
        </SnapshotContainer>
    );
};

CoverAmountsDetails.propTypes = {
    totalRebuildCost: PropTypes.string,
    totalContentReplacementCost: PropTypes.string,
    totalUnspecifiedPortableItems: PropTypes.string,
    bicyclesCover: PropTypes.string,
    jewelryWatchesCover: PropTypes.string,
    clothingCover: PropTypes.string,
    sportingEquipmentCover: PropTypes.string,
    musicalInstrumentsCover: PropTypes.string,
    photographicEquipmentCover: PropTypes.string,
    portableItems: PropTypes.string,
    onClick: PropTypes.func,
    getHref: PropTypes.func
};

export { CoverAmountsDetails };
